import { DEFAULT_WIDGET_SPACING } from '../spacing';
import type { FrontendWidget } from '../types';
import { TextContentWidgetComponent } from './TextContentWidgetComponent';
import { TextContentWidgetComponentB } from './TextContentWidgetComponentB';
import { TextContentWidgetComponentC } from './TextContentWidgetComponentC';
import type {
  TextContentWidgetConfig,
  TextContentWidgetResolved,
} from './types';

export const textContentWidget: FrontendWidget<
  TextContentWidgetConfig,
  TextContentWidgetResolved
> = {
  componentType: 'widgets.title-widget',
  displayName: 'Text Content Widget',
  ComponentA: TextContentWidgetComponent,
  ComponentB: TextContentWidgetComponentB,
  ComponentC: TextContentWidgetComponentC,
  resolveSync: (config) => ({
    ...config,
    alignment: config.alignment ?? 'center',
    // Mirrors the Strapi default, for entries written before the field existed.
    spacing: config.spacing ?? DEFAULT_WIDGET_SPACING,
  }),
};
